import { render, staticRenderFns } from "./d-modal-mobile-alert.vue?vue&type=template&id=0f5b2260&"
import script from "./d-modal-mobile-alert.vue?vue&type=script&lang=js&"
export * from "./d-modal-mobile-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports